<template>
  <div class="subtitle-1 pb-0 pt-3">
    <v-row>
      <v-col cols="12" class="body-2">
          <div class="custom-title">Technical Contact</div>
          <div class="text-caption red--text font-italic ">
            *Details required for <span class="font-weight-bold">Self-Installation Kit(SIK)</span>
          </div>
      </v-col>
      <v-col cols="12" lg="6" class="py-0">
        <ValidationProvider
        name="Contact Firstname"
        :rules="fieldRequired ? 'required' : ''"
        v-slot="{ errors }"
        >
        <v-text-field
          v-model="techDetails.firstName"
          name="Contact Firstname"
          label="Contact Firstname"
          placeholder=" "
          autocomplete="new"
          :error-messages="errors"
          outlined
          dense
          @change="updateContact()"
          :readonly="isOriginal"
        ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" lg="6" class="py-0">
        <ValidationProvider
        name="Contact Lastname"
        :rules="fieldRequired ? 'required' : ''"
        v-slot="{ errors }"
        >
        <v-text-field
          v-model="techDetails.lastName"
          name="Contact Lastname"
          label="Contact Lastname"
          placeholder=" "
          autocomplete="new"
          :error-messages="errors"
          outlined
          dense
          @change="updateContact()"
          :readonly="isOriginal"
        ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" lg="6" class="py-0">
        <ValidationProvider
          name="Contact Email"
          :rules="fieldRequired ? 'required|email' : ''"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="techDetails.email"
            label="Contact Email"
            placeholder=" "
            autocomplete="new"
            :error-messages="errors"
            outlined
            dense
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" lg="6" class="py-0">
        <ValidationProvider
          name="Contact Number"
          :rules="fieldRequired ? 'required|phonenumber' : ''"
          v-slot="{ errors }">
          <v-text-field
            v-model="techDetails.number"
            label="Contact Number"
            maxlength="10"
            placeholder=" "
            autocomplete="new"
            :error-messages="errors"
            outlined
            dense
            @change="updateContact()"
            :readonly="isOriginal"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" lg="12" class="py-0">
        <ValidationProvider
          name="Shipping Address Type"
          :rules="fieldRequired ? 'required' : ''"
          v-slot="{ errors }"
          >
          <v-select
            label="Shipping Address Type"
            :items="shippingOptions"
            v-model="techDetails.shippingType"
            placeholder=" "
            :error-messages="errors"
            dense
            outlined
            autocomplete="new"
            @change="updateContact()"
            :readonly="isOriginal"
          ></v-select>
        </ValidationProvider>
      </v-col>
    </v-row>
      <v-row v-if="isAlternateAddress">
      <v-col cols="12" lg="6" class="py-0">
        <ValidationProvider
          name="Address Line"
          :rules="isAlternateAddress ? 'required' : ''"
          v-slot="{ errors }">
          <v-text-field
            v-model="techDetails.shipping.addressLine"
            label="Address Line"
            placeholder=" "
            autocomplete="new"
            :error-messages="errors"
            outlined
            dense
            @change="updateContact()"
            :readonly="isOriginal"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" lg="6" class="py-0">
        <ValidationProvider
          name="Suburb"
          :rules="isAlternateAddress ? 'required' : ''"
          v-slot="{ errors }">
          <v-text-field
            v-model="techDetails.shipping.suburb"
            label="Suburb"
            placeholder=" "
            autocomplete="new"
            :error-messages="errors"
            outlined
            dense
            @change="updateContact()"
            :readonly="isOriginal"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" lg="6" class="py-0">
        <ValidationProvider
          name="State"
          :rules="isAlternateAddress ? 'required' : ''"
          v-slot="{ errors }">
          <v-text-field
            v-model="techDetails.shipping.state"
            label="State"
            placeholder=" "
            autocomplete="new"
            :error-messages="errors"
            outlined
            dense
            @change="updateContact()"
            :readonly="isOriginal"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" lg="6" class="py-0">
        <ValidationProvider
          name="Postcode"
          :rules="isAlternateAddress ? 'required' : ''"
          v-slot="{ errors }">
          <v-text-field
            v-model.number="techDetails.shipping.postcode"
            label="Postcode"
            type="number"
            placeholder=" "
            autocomplete="new"
            :error-messages="errors"
            outlined
            dense
            @change="updateContact()"
            :readonly="isOriginal"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="12" class="py-0">
        <ValidationProvider
          name="Authority to Leave"
          :rules="fieldRequired ? 'required' : ''"
          v-slot="{ errors }">
          <div style="display: inline-block; font-size: 16px" class="mr-7">
            Authority to Leave
          </div>
          <v-radio-group
            v-model="techDetails.auth"
            row
            style="display: inline-block"
            :error-messages="errors"
            @change="updateContact()"
            :readonly="isOriginal"
          >
            <v-radio label="Yes" :value="true"></v-radio>
            <v-radio label="No" :value="false"></v-radio>
          </v-radio-group>
        </ValidationProvider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "NbnTechnicalDetails",
  props: {
    fieldRequired: { type: Boolean, required: true },
  },
  data: () => ({
    techDetails: {
      firstName: "",
      lastName: "",
      email:"",
      shippingType: "Same as Location Address",
      shipping: {
        fullAddress: "",
        addressLine: "",
        suburb: "",
        state: "",
        postcode: "",
      },
      auth: true
    },
    shippingOptions: ["Same as Location Address", "Alternate Address"],
  }),
  computed: {
    isAlternateAddress() {
      let vm = this;
      return vm.techDetails.shippingType === "Alternate Address";
    },
  },
  methods: {
    updateContact() {
      let vm = this;

      if (vm.isAlternateAddress)
        vm.techDetails.shipping.fullAddress = `${vm.techDetails.shipping.addressLine}, ${vm.techDetails.shipping.suburb} ${vm.techDetails.shipping.state} ${vm.techDetails.shipping.postcode}`;
      else {
        vm.techDetails.shipping.fullAddress = vm.sqNbnResult.address.formattedAddress
      }

      vm.$emit("updateContact", vm.techDetails);
    },
    cancelUpdate() {
      let vm = this;

      vm.techDetails = {
        firstName: "",
        lastName: "",
        number: "",
        shippingType: "Same as Location Address",
        shipping: {
          fullAddress: "",
          addressLine: "",
          suburb: "",
          state: "",
          postcode: "",
        },
        auth: true
      };

      if (
        window.confirm(
          "Contact details are required. Are you sure you want to cancel?"
        ) === true
      ) {
        vm.$emit("cancelUpdate");
      }
    },
    setTechnicalDetails(){
      let vm = this;
      vm.techDetails.firstName = vm.nbnOrder.contactFirstname;
      vm.techDetails.lastName = vm.nbnOrder.contactSurname;
      vm.techDetails.number = vm.nbnOrder.contactNumber;
      vm.techDetails.shippingType = vm.nbnOrder.shippingType;
      vm.techDetails.auth = vm.nbnOrder.authToLeave;
      vm.techDetails.email = vm.nbnOrder.contactEmail;
      vm.techDetails.shipping = vm.nbnOrder.shippingAddress;
    }
  },
  mounted() {
    let vm = this
    if(vm.isOriginal) {
      vm.techDetails = {
        firstName: vm.nbnOrder.contactFirstname,
        lastName: vm.nbnOrder.contactSurname,
        number: vm.nbnOrder.contactNumber,
        email:vm.nbnOrder.contactEmail !== undefined? vm.nbnOrder.contactEmail:"",
        shippingType: vm.nbnOrder.shippingType,
        shipping: vm.nbnOrder.shippingAddress,
        auth: vm.nbnOrder.authToLeave
      };
    }

  }
};
</script>
